import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, CircularProgress, Divider } from '@mui/material';

import AppToast from '@shared/AppToast';
import axiosRails from '@utils/axios-rails';

const defaultError = I18n.t("actions.default_error");

// Replaces Polaris' <PageActions>: a rule above the row, destructive action on
// the left and the primary one on the right. No <Frame> ancestor is needed any
// more — AppToast portals itself.
class FormPageActions extends Component {
  state = {
    localLoading: false,
    showToast: false,
    toastMessage: "",
  }
  render() {
    const { localLoading, showToast, toastMessage } = this.state;
    const props = this.props;
    const loading = props.loading || localLoading;

    return (
      <div className="mt10">
        <Divider />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 2 }}>
          <div>
            { props.deleteURL &&
              <Button
                variant="outlined"
                color="error"
                disabled={ loading }
                startIcon={ loading ? <CircularProgress size={16} color="inherit" /> : null }
                onClick={ this.handleDelete }
              >
                { props.deleteText || I18n.t("actions.delete") }
              </Button>
            }
          </div>

          {/* Extra secondary actions sit on the same row as save, so a page's actions read as one group */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            { (props.secondaryActions || []).map((action, index) => (
              <Button
                key={index}
                variant="outlined"
                color={ action.destructive ? 'error' : 'inherit' }
                disabled={ loading || action.disabled }
                onClick={ action.onAction }
              >
                { action.content }
              </Button>
            ))}

            { props.onPrimaryAction &&
              <Button
                variant="contained"
                disabled={ loading }
                startIcon={ loading ? <CircularProgress size={16} color="inherit" /> : null }
                onClick={ props.onPrimaryAction }
              >
                { I18n.t("actions.save") }
              </Button>
            }
          </Box>
        </Box>

        { showToast &&
          <AppToast
            content={toastMessage}
            onDismiss={this.toggleToast} />
        }
      </div>
    );
  }

  // TODO use a modal instead of confirm
  handleDelete = async () => {
    if (confirm('Esta acción es irreversible, continuar?')) {
        // Save it!
      await this.setState({ localLoading: true });
      try {
        const response = await axiosRails.delete(this.props.deleteURL);
        const { data } = response;
        if(data.success){
          alert("Eliminado con éxito");
          window.location = data.redirectURL;
        }
        else{
          // alert("An error ocurred. ");
          await this.setState({
            showToast: true,
            toastMessage: data.message || (data.errors && data.errors.base) || defaultError
          })
          console.log(data);
        }
      } catch (error) {
        alert("Ocurrio un error.")
      }
      await this.setState({ localLoading: false });
    } else {
      // Do nothing!
    }
  }

  toggleToast = () => {
    this.setState(({showToast}) => ({showToast: !showToast}));
  };
}


FormPageActions.propTypes = {
  onPrimaryAction: PropTypes.func,
  loading: PropTypes.bool,
  deleteURL: PropTypes.string,
  deleteText: PropTypes.string,
  secondaryActions: PropTypes.array,
};

FormPageActions.defaultProps = {

}


export default FormPageActions;
